<template>
  <div class="app-container">
    <el-form ref="dataForm" :model="formData" label-width="120px">
      <el-tabs type="border-card">
        <el-tab-pane label="网站信息">
          <el-row :span="20">
            <el-col :span="5">
              <el-form-item label="网站LOGO">
                <FileList v-model="formData.website_logo" :item-width="100" :item-height="100" :limit="1" />
                <div class="el-upload__tip">网站logo图片大小为【296px x 296px】</div>
              </el-form-item>
            </el-col>
            <!--            <el-col :span="5">-->
            <!--              <el-form-item label="网站ICO">-->
            <!--                <FileList v-model="formData.website_ico" :item-width="100" :item-height="100" :limit="1"/>-->
            <!--                <div class="el-upload__tip">网站ICO图片大小为【60px x 60px】</div>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
          </el-row>
          <el-row :span="18">
            <el-col :span="6">
              <el-form-item label="网站名称">
                <el-input v-model="formData.website_name" placeholder="请输入网站名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="蒙ICP备案">
                <el-input v-model="formData.icp_filing" placeholder="请输入蒙ICP备案"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="蒙公安网备">
                <el-input v-model="formData.filing" placeholder="请输入蒙公安网备"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="18">
            <!-- <el-col :span="6">
              <el-form-item label="电话（传真）">
                <el-input v-model="formData.telephone" placeholder="请输入电话（传真）"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮编">
                <el-input v-model="formData.postal_code" placeholder="请输入邮编"></el-input>
              </el-form-item>
            </el-col> -->
            <!--                        <el-col :span="6">-->
            <!--                          <el-form-item label="官方地址">-->
            <!--                            <el-input v-model="formData.website" placeholder="请输入官方地址"></el-input>-->
            <!--                          </el-form-item>-->
            <!--                        </el-col>-->
          </el-row>
          <el-row :span="18">
            <el-col :span="18">
              <el-form-item label="版权信息">
                <el-input v-model="formData.copyright" placeholder="请输入版权信息"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-tab-pane>
      </el-tabs>
    </el-form>
    <sticky :z-index="1000" direction="bottom">
      <el-card shadow="always" :body-style="{padding:'15px','text-align':'center'}">
        <el-button type="primary" icon="el-icon-upload" @click="SaveData()">提交</el-button>
      </el-card>
    </sticky>
  </div>
</template>

<script>
import Sticky from '@/components/Sticky' // 粘性header组件
import FileList from '@/components/attachment/FileList'

// import Tinymce from '@/components/Tinymce'
import api from '@/api/configure'
// import AttachmentList from '@/components/attachment/AttachmentList'
import commonList from '@/utils/commonList'
// import WangEditor from '@/components/WangEditor/index.vue'

export default {
  components: {
    // WangEditor,
    Sticky,
    FileList
    // AttachmentList
  },

  mixins: [commonList],
  data() {
    return {
      api,
      formData: {
        id: '',
        website_name: '',
        website_ico: '',
        website_logo: '',
        website_weixin: '',
        volunteer: '',
        index_banner_link: '',
        index_banner: '',
        address: '',
        website: '',
        postal_code: '',
        telephone: '',
        filing: '',
        icp_filing: ''
      }
    }
  },
  mounted: function() {
    this.fetchData()
  },
  methods: {
    SaveData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          api.Save(this.formData).then((response) => {
            this.$notify({ title: '成功', message: response.message, type: 'success', duration: 2000 })
          })
        }
      })
    },
    fetchData() {
      api.Get().then(response => {
        if (response.data != null) {
          this.formData = response.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
